import { VERSION_DATABASE } from "@/config/config";

export const DB_NAME = 'myDB';

/**
 * Versión del esquema de tu DB.
 * Usado junto a PRAGMA user_version para manejar migraciones.
 */
export const DB_VERSION = VERSION_DATABASE;
